import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_DATEINPUTS } from '@progress/kendo-angular-dateinputs';
import { KENDO_FORMFIELD } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { ControlWrapperComponent } from '@unity/forms/composed/control-wrapper/control-wrapper.component';

@Component({
  selector: 'unity-selector-date-control',
  standalone: true,
  imports: [KENDO_FORMFIELD, KENDO_DATEINPUTS, KENDO_LABEL, ReactiveFormsModule, ControlWrapperComponent],
  templateUrl: './selector-date-control.component.html',
  styleUrl: './selector-date-control.component.scss',
})
export class SelectorDateControlComponent {
  public readonly $control = input.required<FormControl<Date | null>>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $showHint = input(true, { alias: 'showHint' });
}
